import React from 'react';
import PropTypes from 'prop-types';

export const IconTwitter = ({ className }) => (
  <svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24.981 5.054a10.882 10.882 0 01-3.135 1.527A4.472 4.472 0 0014 9.576v.998a10.641 10.641 0 01-8.984-4.522s-3.994 8.984 4.991 12.977a11.62 11.62 0 01-6.988 1.997c8.985 4.991 19.965 0 19.965-11.48 0-.278-.027-.556-.08-.829a7.707 7.707 0 002.077-3.663z" fill="#A3ACB3" />
  </svg>
);

IconTwitter.propTypes = {
  className: PropTypes.string,
};

IconTwitter.defaultProps = {
  className: '',
};
